import { useState } from "react";

import { PrimeIcons } from "primereact/api";
import { Button } from "primereact/button";
import { useForm } from "react-hook-form";
import { useConfirmDialogExit } from "hooks";
import { addNewUser } from "services/UserService";
import { useSnackbar } from "providers/SnackbarProvider";
import {
  buttonAddUser,
  formAddUser,
  modalAddUserSubTitle,
  modalAddUserTitle,
  snackbarDetailEmailSentToUser,
  snackbarSummarySuccessSendEmail,
} from "_constants";
import {
  SingleStepBody,
  SingleStepDialog,
  SingleStepFooter,
  SingleStepHeaders,
} from "components/SingleStepDialog";
import { useAppDispatch } from "store/store";
import { setAddUserEmailValidation } from "store/slicer/FormAddUserValidationSlice";
import { FormAddUser } from "components/form/FormAddUser";

export const ButtonAddUser = () => {
  const dispatch = useAppDispatch();
  const [visible, setVisible] = useState(false);
  const { showSnackbar } = useSnackbar();
  const { showConfirmDialogExit } = useConfirmDialogExit();
  const showSingleStepDialog = () => {
    dispatch(setAddUserEmailValidation(true));
    setVisible(true);
  };

  const handleAddData = () => {
    setVisible(false);
  };

  const { handleSubmit, control, setValue, getValues, trigger } = useForm({
    defaultValues: {
      name: "",
      lastName: "",
      email: "",
      role: 0,
    },
    shouldFocusError: false,
    mode: "onChange",
  });
  const onSubmit = (formData: any) => {
    addNewUser(formData)
      .then((_) => {
        showSnackbar({
          severity: "success",
          summary: snackbarSummarySuccessSendEmail,
          detail: snackbarDetailEmailSentToUser,
          life: 5000,
        });
        resetFormState();
      })
      .catch((error) => {
        if (error?.response?.status === 409) {
          dispatch(setAddUserEmailValidation(false));
        }
      });
  };

  const handleDismiss = () => {
    if (control._getDirty()) {
      showConfirmDialogExit({ rejectCallback: resetFormState });
    } else {
      resetFormState();
    }
  };

  const resetFormState = () => {
    setValue("role", 0);
    control._reset();
    setVisible(false);
  };

  return (
    <>
      <Button
        className="button-add-user"
        label={buttonAddUser}
        icon={PrimeIcons.PLUS}
        onClick={showSingleStepDialog}
      />
      <SingleStepDialog
        onHideCallback={handleDismiss}
        height="333px"
        width="700px"
        header={
          <SingleStepHeaders
            title={modalAddUserTitle}
            subtitle={modalAddUserSubTitle}
          />
        }
        body={
          <SingleStepBody
            content={
              <form
                id={formAddUser}
                onSubmit={handleSubmit(onSubmit)}
                className="width-100 padd-top-4"
              >
                <FormAddUser
                  control={control}
                  getValues={getValues}
                  trigger={trigger}
                />
              </form>
            }
          />
        }
        footer={
          <SingleStepFooter
            dismiss={handleDismiss}
            form="add-user"
            handleAddData={handleAddData}
          />
        }
        display={visible}
        setVisible={setVisible}
      />
    </>
  );
};
